import instance from '@/api/index.js'
const urlPrefix = '/v1/dashboard'
export default {
  getBullet (){
    return instance({
      method: 'get',
      url: `${urlPrefix}/bullet`,
    })
  },
}
